<template>
	<div class="main">
		<div class="product">
            <div class="pro"><router-link :to="{path:'/'}" class="link"><span >{{$t('nav.home')}} > </span></router-link><router-link :to="{name:'product'}" class="link"><span >{{$t('nav.pro')}} > </span></router-link><span> {{$route.query.name}}</span></div>
			<div class="h_title">
                <el-image src="./static/image/tleft.png" fit="contain"></el-image>{{$t('nav.pro')}}
                <el-image src="./static/image/tright.png" fit="contain"></el-image>
		    </div>
            <div class="list">
                <div class="shop" v-for="(val,index) in product" :key='index'>
                    <el-image :src="val.image" class="ad" fit="fill"></el-image>
                    <div class="title" v-if="$i18n.locale == 'zh'">
                        {{val.name}}
                    </div>
										<div class="title" v-else-if="$i18n.locale == 'en'">
                        {{val.y_name}}
                    </div>
										<div class="title" v-else>
                        {{val.e_name}}
                    </div>
                    <div class="link" @click="toProductDetail(val)">
                        {{$t('more')}}<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
                    </div>
                </div>
                <!-- <div class="shop">
                    <el-image src="./static/image/head1.png" class="ad" fit="fill"></el-image>
                    <div class="title">
                        医药中间体
                    </div>
                    <div class="link" @click="$router.push({ path: '/product/productdetail' })">
                        查看更多<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
                    </div>
                </div>
                <div class="shop">
                    <el-image src="./static/image/head1.png" class="ad" fit="fill"></el-image>
                    <div class="title">
                        原料药
                    </div>
                    <div class="link" @click="$router.push({ path: '/product/productdetail' })">
                        查看更多<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
                    </div>
                </div>
                <div class="shop">
                    <el-image src="./static/image/head1.png" class="ad" fit="fill"></el-image>
                    <div class="title">
                        原料药原料药
                    </div>
                    <div class="link" @click="$router.push({ path: '/product/productdetail' })">
                        查看更多<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
                    </div>
                </div> -->
            </div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				product:[],
			}
		},
		mounted() {
			this.getPor()
		},
		methods: {
			// 去详情页面
			toProductDetail(val){
				var name = {
					name:val.name,
					y_name:val.y_name,
					e_name:val.e_name,
				};
				// if(this.$i18n.locale == 'zh'){
				//  	name = val.name
				// }else if($i18n.locale == 'en'){
				// 	name = val.y_name
				// }else{
				// 	name = val.e_name
				// }
				// this.$router.push({ path:'/product/productdetail?id='+val.id+'&name='+name })
				this.$router.push({ path:'/product/productdetail?id='+val.id+'&name='+JSON.stringify(name) })

			},
			// 
			getPor() {
				var that = this;
				this.$axios
					.post("/api/index/get_type", {
						id:this.$route.query.id
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.product = ret.data.data.type;
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
		}
	}
</script>

<style lang="scss" scoped>
	.main {
		background-color: #FFFFFF;
		width: 100%;
		display: flex;
		align-items: center;
		flex-direction: column;

		.introduce {
			width: 1200px;
			height: 433px;
			margin: 60px 0;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.ad {
				width: 800px;
				height: 433px;
			}

			.info {
				width: 800px;
				height: 433px;
				padding-left: 40px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.title {
					font-size: 30px;
					color: #004098;
					font-weight: bold;
				}

				span {
					display: block;
					width: 40px;
					height: 4px;
					background: #004098;
					margin-top: 20px;
				}

				.cro {
					font-size: 18px;
					color: #333;
					margin: 20px 0;
				}

				.text {
					height: 300px;

					p {
						font-size: 16px;
						color: #999;
						text-indent: 2em;
					}

				}

				.link {
					font-size: 16px;
					color: #004098;
					display: flex;
					align-items: center;
					cursor: pointer;

					.el-image {
						width: 16px;
						height: 16px;
						margin-left: 5px;
					}
				}
			}

			.info2 {
				background-color: #F7F8FA;
				padding: 50px 40px;
			}
		}

		.census {
			width: 100%;
			height: 363px;
			position: relative;

			.el-image {
				width: 100%;
				height: 363px;
			}

			.info {
				width: 100%;
				height: 363px;
				position: absolute;
				top: 0;
				left: 0;
				background-color: rgba($color: #004098, $alpha: 0.8);
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0 200px;

				.li {
					width: 100%;
					color: #fff;
					display: flex;
					align-items: center;
					flex-direction: column;
					font-size: 16px;

					.num {
						font-size: 60px;
						font-weight: bold;
					}

					.title {
						font-size: 24px;
						margin-bottom: 10px;
					}

					span {
						display: block;
						width: 40px;
						height: 3px;
						background: #FFFFFF;
					}

					.text {
						margin-top: 20px;
						text-align: center;
					}
				}
			}
		}

		.h_title {
			font-size: 30px;
			color: #004098;
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 1200px;
			padding: 40px 0;
			font-weight: bold;

			.el-image {
				width: 515px;
				height: 13px;
			}
		}

		.range {
			width: 1200px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.li {
				font-size: 16px;
				color: #333;
				display: flex;
				align-items: center;
				flex-direction: column;

				.el-image {
					width: 70px;
					height: 70px;
					padding: 15px;
					margin-bottom: 15px;
					background-color: #004098;
				}
			}
		}

		.el-carousel {
			width: 1200px;
		}

		.product {
			width: 100%;
			background-color: #F7F8FA;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding-bottom: 60px;

			.list {
				width: 1200px;
				display: flex;
				align-items: flex-start;
				// justify-content: space-between;
                flex-wrap:wrap;
				
				.shop {
					width: 390px;
					height: 400px;
					background: #FFFFFF;
					padding: 20px;
					display: flex;
					flex-direction: column;
                    margin-bottom: 20px;
					margin-right:20px;
					.el-image {
						width: 350px;
						height: 260px;
					}
					.title {
						font-size: 20px;
						color: #333;
						margin: 15px 0;
					}

					.text {
						font-size: 16px;
						color: #666;
					}

					.link {
						font-size: 16px;
						color: #004098;
						display: flex;
						align-items: center;
						cursor: pointer;
						margin-top: 10px;

						.el-image {
							width: 16px;
							height: 16px;
							margin-left: 5px;
						}
					}
				}
			}
		}
		.list .shop:nth-child(3n){
            margin-right: 0;
		}
        .pro{
            width: 1200px;
            line-height:30px;
            margin:40px 0 0;
            overflow: hidden;
            text-align: left;
        }	
		
	}
</style>



// WEBPACK FOOTER //
// src/components/product/second.vue